export default "__VITE_ASSET__B$op$kPp__"